class Controller {
  constructor(Events, Captain, Country) {
    "ngInject";

    this.Events = Events;
    this.Captain = Captain;
    this.Country = Country;

    this.isChecking = false;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.Country.getAllActive({ isCityRequired: false }).$promise.then(
      (response) => {
        this.countries = response;
      }
    );
  }

  checkVerification() {
    this.isChecking = true;
    this.Captain.verifyOTP({
      phone: this.captainPhone,
      country_code: this.countryCode,
    })
      .$promise.then((response) => {
        this.otpVerification = {
          otp: response.otp,
          expiryDate: new Date(response.expiry_date).toUTCString(),
        };
      })
      .catch((err) => {
        this.Events.emit(this.errorNotificationEvent, err.data);
      })
      .finally(() => {
        this.isChecking = false;
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captainVerification/captainVerification.controller.js